import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { getColor, getSize } from '../../hooks';
import { WarningTag } from './warning-tag.component';
import { Tooltip } from 'antd';
import { AudioOutlined, BookOutlined, EditOutlined, WechatOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledMoreTags = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  padding: 0 ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  cursor: pointer;\n  position: relative;\n  height: 24px;\n  display: flex;\n  align-items: center;\n\n  &:hover .all-tags {\n    display: flex;\n  }\n"])), getColor('fillIntSubActive'), getColor('contentMinimum'), getSize('padding4'), getSize('radius'), getSize('typo12'));

var truncateText = function truncateText(text, maxLength) {
  return text.length > maxLength ? "".concat(text.slice(0, maxLength), "...") : text;
};

var itemIcon = {
  Reading: /*#__PURE__*/_jsx(BookOutlined, {}),
  Writing: /*#__PURE__*/_jsx(EditOutlined, {}),
  Listening: /*#__PURE__*/_jsx(AudioOutlined, {}),
  Speaking: /*#__PURE__*/_jsx(WechatOutlined, {})
};
export var MoreTagsWithIcon = function MoreTagsWithIcon(_ref) {
  var tags = _ref.tags;
  var firstThreeTags = tags && tags.length > 0 ? tags.slice(0, 2) : [];
  var remainingTags = tags && tags.length > 0 ? tags.slice(2) : [];
  var isRemainingTags = remainingTags.length > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [firstThreeTags.map(function (tag) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: tag.key,
        children: /*#__PURE__*/_jsx(WarningTag, {
          icon: itemIcon[tag.key],
          children: /*#__PURE__*/_jsx("span", {
            children: truncateText(tag.key, 10)
          })
        }, tag.id.toString())
      });
    }), isRemainingTags && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx("div", {
        children: remainingTags.map(function (tag, index) {
          return /*#__PURE__*/_jsxs("span", {
            children: [tag.key, index < tags.slice(1).length - 1 ? ', ' : '']
          }, tag.id.toString());
        })
      }),
      children: /*#__PURE__*/_jsxs(StyledMoreTags, {
        children: ["+", tags.length - 1]
      })
    })]
  });
};